//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Form from 'vform'
import { mapGetters } from 'vuex'
import searchInput from '~/mixins/search/search-input'
import searchLocationInput from '~/components/search/search-location-input.vue'

export default {
  name: 'SearchDestinationInputModal',
  components: { searchLocationInput },
  mixins: [searchInput],
  data () {
    return {
      form: new Form({
        searchInput: '',
        locations: []
      })
    }
  },
  computed: {
    ...mapGetters({
      autocomplete: 'search/autocomplete'
    })
  },
  methods: {
    setLocations (locations) {
      this.form.locations = locations
      this.$emit('setLocations', this.form?.locations)
    },
    onBeforeOpen (data) {
      if (data.params?.form?.locations) {
        this.form.locations = data.params.form.locations
      }
    },
    onClose () {
      this.$emit('close')
      this.$nuxt.$emit('onCloseDestinationInputModal', this.form)
    }
  }
}
